$ = require 'jquery'
Alerts = require 'app/scripts/views/lib/alerts'
Auth = require 'app/scripts/db/auth'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
log = require 'app/scripts/debug/log'
templates = require 'app/scripts/views/internal/templates'
l = require 'app/scripts/lib/localize'

module.exports = AjaxQueue = new class

  constructor: ->
    @_msBackoff = 100
    @_msBackoffMin = 100
    @_nTriesLeft = 12
    @_nTriesMax = 12
    @_retrying = false
    @_stopped = false
    @_maxLength = 10

    @_queue = []
    @_queueIdSeq = 0

  uniqueReqId: -> "#{Auth.me()?.id}-#{Math.random()}"

  hasQueue: -> @_queue.length > 0
  inQueue: (req) -> _.find(@_queue, (r) -> r.queueId == req.queueId)
  removeFromQueue: (req) -> @_queue = _.filter(@_queue, (r) -> r.queueId != req.queueId)
  addToQueue: (req) ->
    log('AjaxQueue', 'addToQueue', req)
    if @_queue.length + 1 > @_maxLength
      log('AjaxQueue', "maxLength exceeded")
      return
    @_queue.push(req)
    @showRetrying()

  success: (req) ->
    log('AjaxQueue', "success", req)
    if @inQueue(req)
      @removeFromQueue(req)
      @_retrying = false
      @_msBackoff = @_msBackoffMin
      @_nTriesLeft = @_nTriesMax
      @retryNext()

  retryableError: (req) ->
    log('AjaxQueue', 'retryableError', req)
    if AjaxQueue.inQueue(req)
      @_retrying = false
    else
      AjaxQueue.addToQueue(req)
    @retryNext()

  serverAlreadySaw: (req) ->
    if @inQueue(req)
      @removeFromQueue(req)
      @retryNext()

  retryNext: ->
    if @_stopped
      return
    if !@hasQueue()
      @hideRetrying()
      return
    @showRetrying()
    if @_retrying
      return
    @_retrying = true
    req = @_queue[0]
    if @_nTriesLeft > 0
      log('AjaxQueue', "retrying in #{@_msBackoff}ms", req)
      setTimeout (-> $.ajax(req)), @_msBackoff
      @_msBackoff *= 2
      --@_nTriesLeft
    else
      @_stopped = true
      @showOutOfRetries()

  showRealError: (xhr, textStatus, err) ->
    log('AjaxQueue', 'showRealError', err)
    @hideRetrying()
    msg = l('alerts.changes not saved')
    Alerts.showHtml templates.fill('connect_failed', { msg }),
      'error',
      'AjaxQueueFail'

  showOutOfRetries: ->
    log('AjaxQueue', 'showOutOfRetries')
    @hideRetrying()
    msg = l('alerts.timed out')
    Alerts.showHtml templates.fill('connect_failed', { msg }),
      'error',
      'AjaxQueueFail'

  showRetrying: ->
    n = @_queue.length

    Alerts.show('retrying', 'error', 'AjaxQueueRetry')

  hideRetrying: -> Alerts.hide('AjaxQueueRetry')

  showSending: -> Alerts.show('sending', 'warning', 'AjaxQueueSending')

  hideSending: -> Alerts.hide('AjaxQueueSending')

  showUploading: (status) ->
    Alerts.show(status, 'info', 'AjaxQueueUpload')

  hideUploading: -> Alerts.hide('AjaxQueueUpload')

  ajax: (reqIn) ->
    req = _.clone(reqIn)

    if @_stopped
      return
    req.timeout ?= 32000
    req.showSendingAfter ?= 3000
    req.queueId = @_queueIdSeq++
    req.headers = 'X-Trello-ReqId': @uniqueReqId()

    req.oldSuccess = req.success
    req.oldError = req.error
    req.ourComplete = req.complete
    delete req.complete

    modelCache = req.modelCache
    delete req.modelCache

    retry = req.retry ? true
    delete req.retry

    completed = false
    isUpload = false

    lockIndex = modelCache?.lock('AjaxQueue.ajax')

    req.success = (args...) ->
      AjaxQueue.hideSending()
      AjaxQueue.hideUploading()
      completed = true
      AjaxQueue.success(@)
      @oldSuccess?(args...)
      @ourComplete?()
      modelCache?.unlock(lockIndex)

    req.error = (args...) ->
      AjaxQueue.hideSending()
      AjaxQueue.hideUploading()
      completed = true
      [xhr, textStatus, err] = args
      if retry && xhr.status in [0, 408, 500]
        AjaxQueue.retryableError(@)
      # For the moment, treat 412 just the same as other errors
      #else if xhr.status in [412]
      #  # We already sent this reqId, response must have been lost or server crashed
      #  log('AjaxQueue', "Server responded with status code 412 - already saw this reqId")
      #  AjaxQueue.serverAlreadySaw(@)
      #  @oldError?(args...)
      else
        defaultErrorHandler = ->
          AjaxQueue._stopped = true
          AjaxQueue.showRealError(args...)

        if _.isFunction(@oldError)
          @oldError(args..., defaultErrorHandler)
        else
          defaultErrorHandler()

        @ourComplete?()
        modelCache?.unlock(lockIndex)

    if /^post$/i.test(req.type)
      isLongUpload = (evt) ->
        evt.lengthComputable && evt.total > 64 * 1024

      req.xhr = =>
        xhr = new XMLHttpRequest()
        upload = xhr.upload
        if upload?
          upload.addEventListener 'progress', (evt) =>
            return if !isLongUpload(evt)
            isUpload = true

            percentString = Math.round(100 * evt.loaded / evt.total).toString() + '%'
            @showUploading ['uploading', { percentString }]

          upload.addEventListener 'load', (evt) =>
            return if !isUpload
            @showUploading 'processing upload'

        xhr


    if @hasQueue()
      # We currently have a request in retry, so add this to the queue
      AjaxQueue.addToQueue(req)
    else
      # Nothing in the queue, so allow the parallel request
      if req.showSendingAfter >= 0
        setTimeout (=> if !completed && !isUpload then AjaxQueue.showSending()), req.showSendingAfter
      @send(req)

    return

  send: (req) ->
    method = (req.method || req.type || 'get').toUpperCase()
    url = req.url
    args = req.data

    $.ajax(req)

